// extracted by mini-css-extract-plugin
export var section = "SectionTableOfContents-module--section--NDW56";
export var tableOfContents = "SectionTableOfContents-module--tableOfContents--labyj";